import React, { useState, useEffect } from "react";
import { Heading, Input, Button, VStack } from "@chakra-ui/react";
import { useContractKit } from "@celo-tools/use-contractkit";
import { create } from "ipfs-http-client";
import { Image } from "@chakra-ui/image";

import { mintNFT } from "../lib/NFT";
import Layout from "../components/layout";

const infuraUrl = "https://ipfs.infura.io:5001";

function Mint() {
  const { address, performActions } = useContractKit();

  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [royalties, setRoyalties] = useState("");
  const [minting, setMinting] = useState(false);

  async function uploadFileAndMint() {
    setMinting(true);
    const ipfs = create(infuraUrl);

    if (image) {
      console.log("Uploading image");
      const imageHash = await ipfs.add(image);
      console.log(imageHash);
      const metadata = JSON.stringify({
        title: title,
        description: description,
        creator: address,
        image: `ipfs://${imageHash.path}`,
        royalties: royalties,
      });
      const metadataHash = await ipfs.add(Buffer.from(metadata));

      await mintNFT(
        `ipfs://${metadataHash.path}`,
        Number.parseFloat(royalties),
        address,
        performActions
      );
    }
    setMinting(false);
  }

  const ImageUpload = () => {
    const [selectedFile, setSelectedFile] = useState();
    const [preview, setPreview] = useState();

    useEffect(() => {
      if (!selectedFile) {
        setPreview(undefined);
        return;
      }

      const objectUrl = URL.createObjectURL(selectedFile);
      setPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }, [selectedFile]);

    const onSelectFile = (e) => {
      if (!e.target.files || e.target.files.length === 0) {
        setSelectedFile(undefined);
        return;
      }
      setImage(e.target.files[0].arrayBuffer());
      e.target.files[0]
        .arrayBuffer()
        .then((fileBuffer) => setImage(Buffer.from(fileBuffer)));
      setSelectedFile(e.target.files[0]);
    };

    return (
      <VStack justifyContent="start" spacing="4">
        <Input
          type="file"
          p={4}
          h={"110%"}
          onChange={onSelectFile}
          width="100%"
          borderColor="gray.600"
        />
        {selectedFile && <Image src={preview} h="300px" w="300px" />}
      </VStack>
    );
  };

  return (
    <Layout>
    <VStack justifyContent='center'>
      <Heading mb={6}>Create your own NFT</Heading>
      <VStack spacing="4" width={{lg:"xl", md:"xl"}}>
        <Input
          placeholder="title"
          onInput={(e) => setTitle(e.target.value)}
          borderColor="gray.600"
        />
        <Input
          placeholder="description"
          onInput={(e) => setDescription(e.target.value)}
          borderColor="gray.600"
        />
        <Input
          placeholder="royalties"
          onInput={(e) => setRoyalties(e.target.value)}
          borderColor="gray.600"
        />
        {ImageUpload()}

        <Button
          onClick={() => {
            uploadFileAndMint();
          }}
          colorScheme={"teal"}
          size="lg"
        >
          {!minting ? "Mint" : "Minting..."}
        </Button>
      </VStack>
      </VStack>
    </Layout>
  );
}

export default Mint;
